import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { getActiveAccounts } from 'services/api/AccessManagerAPI';

export const useGetTwillioActiveAccounts = (isEnabled = false) => {
    const { data, isLoading, ...rest } = useQuery({
        queryKey: queryKeys.twilioActiveAccounts,
        queryFn: () => getActiveAccounts(),
        enabled: isEnabled,
    });

    return {
        twilioActiveAccounts: data,
        isTwilioActiveAccountsLoading: isLoading,
        ...rest,
    };
};
